import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const lang = localStorage.getItem('edsteel_lang');
    if (lang && lang !== 'de' && (config.method || 'get').toLowerCase() === 'get') {
      config.params = { ...(config.params || {}), lang };
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default api;